import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useContext,
  useReducer
} from 'react';
import { FetchCallbacksContext } from '../..//FetchCallbacks';
import FormBuilderNotificationsView from '../view/FormBuilderNotificationsView';
import GeneralContext from '../../GeneralContext';
import { getAllFields } from '../getAllFields';
import useFetchWithCallbacks from '../../../hooks/useFetchWithCallbacks';
import Loader from '../../../components/Loader';
import { isFieldPlaceHolderAllowed } from '../../../components/engine/EmailDialogEngine';
import { template } from 'lodash';

const FormBuilderNotificationsEngine = ({
  form,
  formId
  // setRemindersDirtyCallback
}) => {
  const { openSnackbar } = useContext(FetchCallbacksContext);
  const fetchAPI = useFetchWithCallbacks();
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [isEmailDialogOpen, setIsEmailDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [templateId, setTemplateId] = useState('');
  const [templateCode, setTemplateCode] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  // const publicEmailTemplates = [
  //   'collaborator_added_email',
  //   'new_entry_not_flagged_completed_email',
  //   'new_entry_flagged_completed_email',
  //   'assigned_to_review_submission',
  //   'updated_entry_not_flagged_completed_email'
  // ];

  useEffect(() => {
    loadEmailTemplates();
  }, []);

  useEffect(() => {
    const filtered = emailTemplates.filter(data =>
      data.title.toLowerCase().includes(searchValue.toLowerCase().trim())
    );
    setFilteredTemplates(filtered);
  }, [searchValue, emailTemplates]);

  const loadEmailTemplates = useCallback(() => {
    setIsLoading(true);
    fetchAPI(
      `/mailer/v1/emails?assetId=${formId}&assetType=forms&category=forms`
    ).then(response => {
      setEmailTemplates(response.results.filter(template => !template?.personalMsg));
      setIsLoading(false);
    });
  }, []);

  const onClickedEdit = id => {
    let matchingTemplates, matchingCode;
    matchingTemplates = emailTemplates.filter(one => one.id === id);
    if (matchingTemplates && matchingTemplates.length) {
      matchingCode = matchingTemplates[0].code || '';
      setTemplateCode(matchingCode);
    }
    setIsEmailDialogOpen(true);
    setTemplateId(id);
  };

  const onSetActive = notificationId => {
    let body = emailTemplates.find(eTmpl => notificationId === eTmpl.id);
    if (typeof body.enabled === 'undefined') {
      body.enabled = false;
    } else {
      body.enabled = !body.enabled;
    }
    if (formId) {
      body.assetId = formId;
      body.assetType = 'forms';
    }

    setIsLoading(true);
    fetchAPI(`/mailer/v1/emails/${notificationId}`, {
      body: body,
      method: 'PUT'
    }).then(res => {
      loadEmailTemplates();
      openSnackbar('success', 'notifications.update-active-status.success');
    });
  };

  const showFieldPlaceholderDropdown = isFieldPlaceHolderAllowed(templateCode);

  const api = {
    form
  };

  const viewProps = {
    showFieldPlaceholderDropdown,
    formId,
    emailTemplates,
    onClickedEdit,
    onSetActive,
    isEmailDialogOpen,
    setIsEmailDialogOpen,
    templateId,
    templateCode,
    setTemplateId,
    setSearchValue,
    searchValue,
    loadEmailTemplates,
    filteredTemplates,
    allFields: getAllFields(form)
  };

  return (
    <GeneralContext.Provider value={api}>
      <Loader isLoading={isLoading} />
      <FormBuilderNotificationsView {...viewProps} />
    </GeneralContext.Provider>
  );
};

export default FormBuilderNotificationsEngine;
